import 'unpoly';

const { up } = window;

// Only log the Unpoly banner in development mode.
up.log.config.banner = (import.meta.env.MODE === 'development');

export default up;
